import { preventDuplicatedRequest } from "@/utilities/async-for-each";
import { getAppCustomEnv } from "@/utilities/get-app-custom-env";
import BaseProxy from "../../base-proxy";
import queryString from "querystring";
import axios from "axios";

export default class PaymentServiceProxy {
  async getCheckoutItems(input = {}, data) {
    const key = data && data.items ? data.items.map((item) => item.itemId).join("") : "";

    return preventDuplicatedRequest(
      "getCheckoutItems" + key,
      async () => {
        let baseProxy = new BaseProxy();
        let backendUrl = await baseProxy.getPaymentBackendUrl();
        let endpointUrl = `${backendUrl}/payment/preview-checkout`;

        return await baseProxy.postAuthenticatedData(endpointUrl, input.authToken, data);
      },
      2000
    );
  }

  async payWithCard(input = {}, data) {
    return preventDuplicatedRequest("payWithCard", async () => {
      let baseProxy = new BaseProxy();
      let backendUrl = await baseProxy.getPaymentBackendUrl();
      let endpointUrl = `${backendUrl}/payment/pay-with-card`;

      return await baseProxy.postAuthenticatedData(endpointUrl, input.authToken, data).then((res) => {
        window.sessionStorage.removeItem("couponCode");
        return res;
      });
    });
  }

  async payWithBank(data = {}, input = {}) {
    return preventDuplicatedRequest("payWithBank", async () => {
      let baseProxy = new BaseProxy();
      let backendUrl = await baseProxy.getPaymentBackendUrl();
      let endpointUrl = `${backendUrl}/payment/pay-with-bank`;

      return await baseProxy.postAuthenticatedData(endpointUrl, data.authToken, input).then((res) => {
        window.sessionStorage.removeItem("couponCode");
        return res;
      });
    });
  }

  async payWithPaymentMethod(data = {}, input = {}) {
    return preventDuplicatedRequest("payWithPaymentMethod", async () => {
      let baseProxy = new BaseProxy();
      let backendUrl = await baseProxy.getPaymentBackendUrl();
      let endpointUrl = `${backendUrl}/payment/pay-with-payment-method`;

      return await baseProxy.postAuthenticatedData(endpointUrl, input.authToken, data);
    });
  }

  async createPaymentIntent(data = {}, input = {}) {
    return preventDuplicatedRequest("createPaymentIntent", async () => {
      let baseProxy = new BaseProxy();
      let backendUrl = await baseProxy.getPaymentBackendUrl();
      let endpointUrl = `${backendUrl}/payment/create-payment-intent`;

      return await baseProxy.postAuthenticatedData(endpointUrl, input.authToken, data);
    });
  }

  async confirmPaymentIntent(data = {}, input = {}) {
    return preventDuplicatedRequest("confirmPaymentIntent", async () => {
      let baseProxy = new BaseProxy();
      let backendUrl = await baseProxy.getPaymentBackendUrl();
      let endpointUrl = `${backendUrl}/payment/confirm-payment-intent`;

      return await baseProxy.postAuthenticatedData(endpointUrl, input.authToken, data);
    });
  }

  async insertPaymentMethod(data = {}, input = {}) {
    return preventDuplicatedRequest("insertPaymentMethod", async () => {
      let baseProxy = new BaseProxy();
      let backendUrl = await baseProxy.getPaymentBackendUrl();
      let endpointUrl = `${backendUrl}/payment-methods`;

      return await baseProxy.postAuthenticatedData(endpointUrl, input.authToken, data);
    });
  }

  async updatePaymentMethod(input = {}, data = {}) {
    return preventDuplicatedRequest("updatePaymentMethod", async () => {
      let baseProxy = new BaseProxy();
      let backendUrl = await baseProxy.getPaymentBackendUrl();
      let endpointUrl = `${backendUrl}/payment-methods/${input.id}`;

      return await baseProxy.putAuthenticatedData(endpointUrl, input.authToken, data);
    });
  }

  async getPaymentMethods(input = {}) {
    return preventDuplicatedRequest("getPaymentMethods", async () => {
      let baseProxy = new BaseProxy();
      let backendUrl = await baseProxy.getPaymentBackendUrl();

      // TODO: Remove this once we have a proper way to switch to sleek-billings
      // will happen when we totally remove payment/subscription service totally
      const appCustomEnv = await getAppCustomEnv();
      if (appCustomEnv.VUE_APP_SLEEK_BILLING_API) {
        try {
          const response = await axios.get(`${appCustomEnv.VUE_APP_SLEEK_BILLING_API}/api/config`);
          if (response.data.SWITCH_TO_SLEEK_BILLINGS === "enabled") {
            backendUrl = await baseProxy.getBillingBackendUrl();
          }
        } catch (error) {
          console.error("Failed to fetch billing config:", error);
        }
      }

      let endpointUrl = `${backendUrl}/payment-methods`;
      if (input.companyId) {
        endpointUrl += `?companyId=${input.companyId}`;
      }

      return await baseProxy.getAuthenticatedData(endpointUrl, input.authToken);
    });
  }

  async deletePaymentMethod(input = {}) {
    return preventDuplicatedRequest("deletePaymentMethod", async () => {
      let baseProxy = new BaseProxy();
      let backendUrl = await baseProxy.getPaymentBackendUrl();
      let endpointUrl = `${backendUrl}/payment-methods/${input.id}`;

      return await baseProxy.deleteAuthenticatedData(endpointUrl, input.authToken);
    });
  }

  async getMyReferralCode(data = {}, input = {}) {
    return preventDuplicatedRequest("getMyReferralCode", async () => {
      let baseProxy = new BaseProxy();
      let backendUrl = await baseProxy.getPaymentBackendUrl();
      let endpointUrl = `${backendUrl}/coupons/my-referral-code`;

      return await baseProxy.getAuthenticatedData(endpointUrl, data.authToken, input);
    });
  }

  async getCouponUsages(data = {}, input = {}) {
    return preventDuplicatedRequest("getCouponUsages", async () => {
      let baseProxy = new BaseProxy();
      let backendUrl = await baseProxy.getPaymentBackendUrl();
      let query = queryString.stringify(input);
      let endpointUrl = `${backendUrl}/coupons/${input.couponId}/usages?${query}`;

      return await baseProxy.getAuthenticatedData(endpointUrl, data.authToken, input);
    });
  }
}
